import { useState, useEffect, useMemo, useRef  } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Typography } from "@mui/material";
import "./Header.css";
import { useForm, Controller, FormProvider } from "react-hook-form";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
//import ModalCard from "./ModalCard";
import NewModalCard from "./NewModalCard";
import { SingleSelectDropDown } from "./SingleSelectDropDown";
import { MultiSelectDropDown } from "./MultiSelectDropDown";
import { getsearchData } from "../helpers/api/projectData";
import {
  convertDate,
  convertDateName,
  formatToINR,
} from "../helpers/helperFunctions";
import { HiMiniEye, HiMiniEyeSlash } from "react-icons/hi2";
import { BiLoaderCircle } from "react-icons/bi";

import { 
  getDivision,getLandscape,getProjects,getProjectCategories
 } from "../helpers/apiServices";




import { Doughnut, Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title,
  // for the Bar Chart:
  CategoryScale, 
  LinearScale,
  BarElement,
} from "chart.js";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  Title,
  ChartDataLabels,
  // New components for Bar Chart:
  CategoryScale,
  LinearScale,
  BarElement
);






function FormPage() {
  const [data, setData] = useState([]);
  const [projectActivityNumbers, setProjectActivityNumbers] = useState([]);
  const [modalData, setModalData] = useState({});
  const [isError, setError] = useState(false);
  const [projectId, setProjectId] = useState();
  const [projectName, setProjectName] = useState();
  const [overallBudget, setBudget] = useState();
  const [postedAmount, setPostedAmount] = useState();
  const [unpostedAmount, setUnpostedAmount] = useState();
  const [loading, setLoading] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [projects, setProjects] = useState([]);
  const [categories, setCategories] = useState([]);
  const [landscapes, setLandscapes] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [loadingLandscapes, setLoadingLandscapes] = useState(false);
  //const [loadingDivisions, setLoadingDivisions] = useState(false);
  const [loadingProjects, setLoadingProjects] = useState(false);

  const { control, handleSubmit, setValue, watch } = useForm({
    defaultValues: {
      division: "",
      landscape: "",
      projectId: "",
      projectCategoryId: "",
      projectcategoryNumber: "",
      isTransaction: false,
      fromDate: "",
      toDate: "",
    },
  });
  const [hasSearched, setHasSearched] = useState(false);
  const [isClearTable, setClearTable] = useState(false);

  // New states to control summary -> view details -> table flow
  const [tableVisible, setTableVisible] = useState(false);
  const [summaryLoaded, setSummaryLoaded] = useState(false);

  // Watch selected landscape and division
  const selectedLandscape = watch("landscape");
  const selectedDivision = watch("division");

  // Donut Chart Data
// const donutData = {
//   labels: ["Posted Amount", "Unposted Amount", "Balance Amount"],
//   datasets: [
//     {
//       data:
//         overallBudget && postedAmount && unpostedAmount
//           ? [
//               postedAmount,
//               unpostedAmount,
//               overallBudget - (postedAmount + unpostedAmount),
//             ]
//           : [0, 0, 0],
//       backgroundColor: ["#22c55e", "#ef4444", "#fbbf24"],
//       hoverBackgroundColor: ["#16a34a", "#b91c1c", "#f59e0b"],
//     },
//   ],
// };

const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 5; // Display 5 Project Activity Numbers at a time

// Memoized filtered and paginated data for the chart
const chartData = useMemo(() => {
  // 1. Filter out "Adv Emp" and "Adv Vendor" categories
  const filteredData = data.filter(row =>
    row.ProjectCategoryId !== "Adv Emp" && row.ProjectCategoryId !== "Adv Vendor"
  );

  // 2. Calculate pagination
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedData = filteredData.slice(startIndex, endIndex);

  // Calculate Balance Amount for each row here
  const finalData = paginatedData.map(row => ({
      ...row,
      BalanceAmountCalculated: Math.max(row.OverallBudgetAmount - (row.PostedAmount + row.UnpostedAmount), 0)
  }));


  return {
    paginatedData: finalData,
    totalPages,
    dataLength: filteredData.length,
  };
}, [data, currentPage, itemsPerPage]); // Re-calculate when data or page changes

const { paginatedData, totalPages, dataLength } = chartData;

// Pagination handlers
const handleNextPage = () => {
  setCurrentPage(prev => Math.min(prev + 1, totalPages));
};

const handlePrevPage = () => {
  setCurrentPage(prev => Math.max(prev - 1, 1));
};
// END of State and Memoization Logic

const tableRef = useRef(null);

  // Effect to load Division data (runs once on component mount)
  useEffect(() => {
    const loadDivisions = async () => {
      try {
        setLoading(true);
        const response = await getDivision();
        const formattedDivisions = response?.divisions?.map((item) => ({
          value: item.division,
          label: item.division,
        }));
        setDivisions(formattedDivisions);
        // Auto-select if only one division is returned
      if (formattedDivisions.length === 1) {
        setValue("division", formattedDivisions[0]);
      }
      } catch (error) {
        toast.error("Error loading divisions");
        console.error("Error fetching divisions:", error);
      } finally {
        setLoading(false);
      }
    };
    loadDivisions();
  }, [setValue]);

  // Effect to load Landscape data, dependent on division selection
  useEffect(() => {
    if (selectedDivision) {
      const loadLandscapes = async () => {
        try {
          setLoadingLandscapes(true);
          // Clear previously selected landscape and projects when division changes
          setValue("landscape", null);
          setLandscapes([]);
          setValue("ProjectId", null);
          setProjects([]);
          setValue("ProjectCategory", []);
          setCategories([]);

          const response = await getLandscape(selectedDivision.value);
          const formattedLandscapes = response?.landscapes?.map((item) => ({
            value: item.landscape,
            label: item.landscape,
          }));
          setLandscapes(formattedLandscapes);
          if (formattedLandscapes.length === 1) {
          setValue("landscape", formattedLandscapes[0]);
        }
        } catch (error) {
          toast.error("Error loading landscapes");
          console.error("Error fetching landscapes:", error);
          setLandscapes([]); // Clear landscapes on error
        } finally {
          setLoadingLandscapes(false);
        }
      };
      loadLandscapes();
    } else {
      // If no division is selected, clear landscapes and related fields
      setValue("landscape", null);
      setLandscapes([]);
      setValue("ProjectId", null);
      setProjects([]);
      setValue("ProjectCategory", []);
      setCategories([]);
    }
  }, [selectedDivision, setValue]); // Re-run when selectedDivision changes

    // Effect to load Projects data, dependent on landscape and division selection
  useEffect(() => {
    if (selectedDivision && selectedLandscape) {
      const loadProjects = async () => {
        setLoadingProjects(true);
        setValue("projectId", null); 
        setValue("ProjectCategory", []); 
        setCategories([]); 
        console.log("Attempting to load projects...");

        try {
          const projectsData = await getProjects(
             selectedDivision.value, 
            selectedLandscape.value 
          );

          console.log("Raw projectsData from API:", projectsData);

          if (projectsData?.projects && projectsData.projects.length > 0) {
            const formattedProjects = projectsData.projects.map((project) => ({
              value:
                project.startDate +
                " to " +
                project.endDate +
                ":" +
                project.projectId,
              label: project.projectId,
            }));
            console.log("Formatted projects for dropdown:", formattedProjects);
            setProjects(formattedProjects);


           
      if (formattedProjects.length === 1) {
        setValue("ProjectId", formattedProjects[0]); 
      }
            
          } else {
            console.log("API returned no projects or empty array.");
            setProjects([]);
          }
        } catch (error) {
          toast.error("Error loading projects");
          console.error("Error fetching projects:", error);
          setProjects([]);
        } finally {
          setLoadingProjects(false);
          console.log("Project loading finished. Loading state:", false);
        }
      };
      loadProjects();
    } else {
      // If either division or landscape is not selected, clear projects and categories
      setValue("ProjectId", null);
      setProjects([]);
      setValue("ProjectCategory", []);
      setCategories([]);
      //setNoProjectsFound(false);
    }
    console.log("Landscape useEffect triggered. New value:", selectedLandscape);
  }, [selectedLandscape, selectedDivision, setValue]); // Re-run when selectedLandscape or selectedDivision changes


// Function to convert "DD-Mon-YYYY" to the HTML required format "YYYY-MM-DD"
const convertDropdownDateToHtmlFormat = (dateString) => {
  if (!dateString) return "";
  const [day, monthName, year] = dateString.split("-");
  
  // Mapping month names to numbers (01 to 12)
  const monthMap = {
    "Jan": "01", "Feb": "02", "Mar": "03", "Apr": "04",
    "May": "05", "Jun": "06", "Jul": "07", "Aug": "08",
    "Sep": "09", "Oct": "10", "Nov": "11", "Dec": "12",
  };
  
  const monthNumber = monthMap[monthName];
  
  if (monthNumber) {
    // Reorder to YYYY-MM-DD, ensuring day/month are two digits (e.g., "01")
    const formattedDay = day.padStart(2, '0');
    return `${year}-${monthNumber}-${formattedDay}`;
  }
  
  // Return an empty string or null if the date format is unexpected
  return ""; 
};

// Watch the entire ProjectId object instead of just .label
const selectedProject = watch("ProjectId");

// useEffect(() => {
//   if (selectedProject && selectedProject.label) {

//     // NEW LOGIC TO EXTRACT AND SET DATES
//     const dateRangeAndId = selectedProject.value;
//     const dateParts = dateRangeAndId.split(":")[0]; // Get "startDate to endDate"
//     const [startDate, , endDate] = dateParts.split(" "); // Split "startDate to endDate"

//     // Set the form values for the date pickers
//     setValue("fromDate", startDate);
//     setValue("toDate", endDate);
//     // ------------------------------------

//     handleProjectChange(selectedProject.label); // Trigger API only when project is selected
//     setValue("ProjectCategory", []);            // Clear D365 selection
//   } else {
//     // ProjectId cleared — reset all dependent fields
//     setCategories([]);
//     setProjectActivityNumbers([]);
//     setValue("ProjectCategory", []);
//      // NEW LOGIC: Clear the date fields when the project is unselected
//     setValue("fromDate", "");
//     setValue("toDate", "");
//     // ------------------------------------
//   }
// }, [selectedProject, setValue]);

useEffect(() => {
  if (selectedProject && selectedProject.value) {
    // 1. Extract raw date strings (e.g., "01-Aug-2024" and "30-Aug-2025")
    const dateRangeAndId = selectedProject.value;
    const dateParts = dateRangeAndId.split(":")[0]; 
    const [rawStartDate, , rawEndDate] = dateParts.split(" "); 
    
    // 2. Convert dates to the required YYYY-MM-DD format
    const startDate = convertDropdownDateToHtmlFormat(rawStartDate);
    const endDate = convertDropdownDateToHtmlFormat(rawEndDate);
    
    // 3. Auto-fill the form fields. This is what finally makes the date picker show the date.
    setValue("fromDate", startDate);
    setValue("toDate", endDate);

    // ... existing logic ...
    handleProjectChange(selectedProject.label); // Trigger API for categories
    setValue("ProjectCategory", []);            // Clear D365 selection
  } else {
    // ProjectId cleared — reset all dependent fields and dates
    setCategories([]);
    setProjectActivityNumbers([]);
    setValue("ProjectCategory", []);
    
    // Clear the date fields
    setValue("fromDate", "");
    setValue("toDate", "");
  }
}, [selectedProject, setValue]);

// Function to handle loading project categories
const handleProjectChange = async (selectedProjectId) => {
  if (!selectedProjectId) return;

  setProjectName("Loading...");

  try {
    const categoriesData = await getProjectCategories(selectedProjectId);

    // Set activity numbers for later reference
    const activityNumbersList = categoriesData?.categories?.map(
      (categoryIds) => ({
        d365Code: categoryIds.d365Code,
        activityNo: categoryIds.projectActivityNo,
      })
    );
    setProjectActivityNumbers(activityNumbersList);

    // Set D365 code dropdown values
    const formattedProjectsCategories = categoriesData?.categories?.map(
      (categoryIds) => ({
        value: categoryIds.d365Code,
        label: categoryIds.d365Code,
      })
    );
    //setCategories(formattedProjectsCategories);
    // START OF NEW/MODIFIED LOGIC
    if (formattedProjectsCategories && formattedProjectsCategories.length > 0) {
        setCategories(formattedProjectsCategories);
        
        // 👈 NEW CODE: Set the form value to the full array of options, selecting all.
        setValue("ProjectCategory", formattedProjectsCategories);
        
        // This is good practice to reset the search state when input changes
        handleSelectionChange(); 
    } else {
        setCategories([]);
        setValue("ProjectCategory", []);
    }
    // END OF NEW/MODIFIED LOGIC
  } catch (error) {
    toast.error("Error loading project categories");
    console.error("Error fetching project categories:", error);
  }
};

  const onSubmit = async (data) => {
    try {
      // Hide table at the start of a new search and mark summary as not yet loaded
      setTableVisible(false);
      setSummaryLoaded(false);

      setBudget("Loading...");
      setPostedAmount("Loading...");
      setUnpostedAmount("Loading...");
      setProjectName("Loading...");
      setHasSearched(true);
      setClearTable(false);
      setProjectId(data.ProjectId.label);
      setFromDate(data.fromDate);
      setToDate(data.toDate);
      setSearchLoading(true);
      setError(false);
      //const tokenDetails = await fetchToken();
      //const tokenData = tokenDetails.access_token;
      const initialLoaders = data.ProjectCategory.map((pc) => {
        const matchingActivity = projectActivityNumbers.find(
          (activity) => activity.d365Code === pc.value
        );

        return {
          ProjectId: data.ProjectId.label,
          ProjectName: "Loading...",
          ProjectCategoryId: pc.value,
          ProjectActivityNumber: matchingActivity
            ? matchingActivity.activityNo
            : "Not Found", // Handle case where no match is found
          ProjectActivityId: "Loading...",
          OverallBudgetAmount: "Loading...",
          PostedAmount: "Loading...",
          UnpostedAmount: "Loading...",
          ProjectTransDateFrom: convertDate(data.fromDate),
          ProjectTransDateTo: convertDate(data.toDate),
        };
      });

      setData(initialLoaders);
      let overallBudget = 0,
        postedAmount = 0,
        unpostedAmount = 0;
      for (const pc of data.ProjectCategory) {
        let reqObj = {
          includeTransactionDetails: "No",
          projectCategoryId: pc.label,
          projectId: data.ProjectId.label,
          projectTransDateFrom: convertDate(data.fromDate),
          projectTransDateTo: convertDate(data.toDate),
          //token: tokenData,
        };

        const matchingActivity = projectActivityNumbers.find(
          (activity) => activity.d365Code === pc.value
        );
        //hard coded to skip addition of "Adv Vendor", "Adv Emp"
        const excludedCategories = ["Adv Vendor", "Adv Emp"];
        const categoryCheck = (pc.label || "").trim();
        try {
          const queryResp = await getsearchData(reqObj);
          setProjectName(queryResp.ProjectName);

          // overallBudget += queryResp.OverallBudgetAmount;
          // postedAmount += queryResp.PostedAmount;
          // unpostedAmount += queryResp.UnpostedAmount;

          if (!excludedCategories.includes(categoryCheck)) {
            overallBudget += queryResp.OverallBudgetAmount;
            postedAmount += queryResp.PostedAmount;
            unpostedAmount += queryResp.UnpostedAmount;
          }

          setData((prevData) =>
            prevData.map((item) =>
              item.ProjectCategoryId === pc.value
                ? {
                    ...item,
                    ProjectId: queryResp.ProjectId,
                    ProjectName: queryResp.ProjectName,
                    ProjectCategoryId: queryResp.ProjectCategoryId,
                    ProjectActivityNumber: matchingActivity
                      ? matchingActivity.activityNo
                      : "Not Found", // Handle case where no match is found
                    ProjectActivityId: queryResp.ProjectActivityId,
                    OverallBudgetAmount: queryResp.OverallBudgetAmount,
                    PostedAmount: queryResp.PostedAmount,
                    UnpostedAmount: queryResp.UnpostedAmount,
                    ProjectTransDateFrom: queryResp.ProjectTransDateFrom,
                    ProjectTransDateTo: queryResp.ProjectTransDateTo,
                  }
                : item
            )
          );
        } catch (err) {
          setError(true);
          console.error(`Error fetching data for ${pc.value}:`, err);
          setData((prevData) =>
            prevData.map((item) =>
              item.ProjectCategoryId === pc.value
                ? {
                    ...item,
                    ProjectId: "Error",
                    ProjectName: "Error",
                    ProjectActivityId: "Error",
                    ProjectActivityNumber: "Error",
                    OverallBudgetAmount: "Error",
                    PostedAmount: "Error",
                    UnpostedAmount: "Error",
                  }
                : item
            )
          );
        }
        setSearchLoading(false);
      }
      setBudget(overallBudget);
      setPostedAmount(postedAmount);
      setUnpostedAmount(unpostedAmount);

      // Mark that summary data has been loaded (this enables the "View Details" button)
      setSummaryLoaded(true);
      // ensure search loading is cleared
      setSearchLoading(false);
    } catch (err) {
      console.error("Error during onSubmit:", err);
    }
  };

  const handleShowDetails = (row) => {
    setModalData({
      includeTransactionDetails: "Yes",
      projectId: row.ProjectId,
      projectCategoryId: row.ProjectCategoryId,
      projectTransDateFrom: row.ProjectTransDateFrom,
      projectTransDateTo: row.ProjectTransDateTo,
      projectName: row.ProjectName,
      overallBudgetAmount: row.OverallBudgetAmount,
      postedAmount: row.PostedAmount || 0,
      unpostedAmount: row.UnpostedAmount || 0,
    });
    setShowModal(true);
  };
  const handleSelectionChange = () => {
    setClearTable(true);
  };

  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const sortedData = [...data];
  if (sortConfig.key) {
    sortedData.sort((a, b) => {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];
      if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const getArrow = (key) => {
    return sortConfig.direction === "asc" ? " ▲" : " ▼";
  };

  return (
    <>
      {loading ? (
        <div>
          <div className="flex items-center justify-center fixed inset-0 bg-gray-100">
            <BiLoaderCircle className="animate-spin text-blue-500" size={50} />
          </div>
        </div>
      ) : (
        <div>
          <FormProvider {...{ control, handleSubmit }}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div
                className="create-user-container"
                style={{ marginTop: "20px" }}
              >
                <div className="form-container ml-4 p-2">
                  <div className="grid grid-cols-4 max-sm:grid-cols-1 max-md:grid-cols-3 gap-4">

                    <SingleSelectDropDown
                      option={divisions}
                      placeholder={"Select Division"}
                      label={"Division"}
                      name="division"
                      control={control}
                      rules={{ required: "Division is required" }}
                      isLoading={loading}
                      hasSearched={hasSearched}
                      onSelectionChange={handleSelectionChange}
                      onChange={(selectedOption) => {
    // If division is cleared, clear landscape, projectId, and ProjectCategory
    if (!selectedOption) {
      // Clear the form field values
      setValue("Landscape", null);
      setValue("ProjectId", null);
      setValue("ProjectCategory", []);
      // Also clear the state variables that hold the options
      setLandscapes([]); 
      setProjects([]); 
      setCategories([]); 
    }
  }}
                    />

                    <SingleSelectDropDown
                      option={landscapes}
                      placeholder={"Select Landscape"}
                      label={"Landscape"}
                      name="landscape"
                      control={control}
                      rules={{ required: "Landscape is required" }}
                      isLoading={loadingLandscapes}
                      hasSearched={hasSearched}
                      disabled={!selectedDivision} 
                      onSelectionChange={handleSelectionChange}
                    />

                    <SingleSelectDropDown
                      option={projects}
                      placeholder={"Select Project Id"}
                      label={"Project Id"}
                      name="ProjectId"
                      control={control}
                      rules={{ required: "Project Id is required" }}
                      isLoading={loadingProjects}
                      hasSearched={hasSearched}
                      disabled={!selectedLandscape} 
                      onSelectionChange={handleSelectionChange}
                    />

                    <MultiSelectDropDown
                      option={categories}
                      placeholder={"Select D365 Code"}
                      label={"D365 Code"}
                      name="ProjectCategory"
                      control={control}
                      rules={{ required: "D365 Code is required" }}
                      isLoading={loading}
                      hasSearched={hasSearched}
                      disabled={!watch("ProjectId") || !watch(unpostedAmount)}
                      onSelectionChange={handleSelectionChange}
                    />
                    <div className="form-group  ">
                      <label className="form-label">From Date</label>
                      <Controller
                        name="fromDate"
                        control={control}
                        rules={{ required: "From Date is required" }}
                        //disabled={!watch(unpostedAmount)}
                        disabled={!watch("ProjectId")}
                        render={({ field, fieldState }) => (
                          <>
                            <input
                              type="date"
                              {...field}
                              className={`form-control ${
                                fieldState.error ? "is-invalid" : ""
                              } mb-2`}
                            />
                            {fieldState.error && (
                              <Typography variant="body2" color="error">
                                {fieldState.error.message}
                              </Typography>
                            )}
                          </>
                        )}
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">To Date</label>
                      <Controller
                        name="toDate"
                        control={control}
                        //disabled={!watch(unpostedAmount)}
                        disabled={!watch("ProjectId")}
                        rules={{
                          required: "To Date is required",
                          validate: (value) => {
                            const fromDate = watch("fromDate");
                            if (new Date(value) < new Date(fromDate)) {
                              return "To Date cannot be before From Date";
                            }
                            return true;
                          },
                        }}
                        render={({ field, fieldState }) => (
                          <>
                            <input
                              type="date"
                              {...field}
                              className={`form-control ${
                                fieldState.error ? "is-invalid" : ""
                              } mb-2`}
                            />
                            {fieldState.error && (
                              <Typography variant="body2" color="error">
                                {fieldState.error.message}
                              </Typography>
                            )}
                          </>
                        )}
                      />
                    </div>
                    <div className="flex justify-start items-center">
                      <button
                        className={`bg-blue-500 text-white font-medium px-4 py-2 rounded ${
                          !watch(unpostedAmount)
                            ? "opacity-50 cursor-not-allowed"
                            : "hover:bg-blue-600"
                        }`}
                        type="submit"
                        disabled={!watch(unpostedAmount)}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </FormProvider>

           {!loading && !isError && data.length > 0 ? (
    <>
      {" "}
       {/* {hasSearched && !isClearTable ? (
                <div className="flex flex-col ml-8 pl-4 mr-8 pr-2 bg-white md:w-1/3 shadow-lg rounded-md">
                  <h3 className="text-base font-bold">
                    {projectName === "Loading..." ? (
                      <BiLoaderCircle className="loading-icon mx-auto mt-4" />
                    ) : (
                      projectName
                    )}
                  </h3>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-700 text-xs">{projectId}</span>
                    <span className="text-gray-700 text-xs">
                      <span className="text-gray-900 text-xs">
                        Proj Duration:{" "}
                      </span>
                      {watch("ProjectId")?.value?.split(":")[0] || "N/A"}
                    </span>
                  </div>
                  <hr className="mt-2 mb-2 border-gray-700" />
                  <div className="flex">
                    <p className="font-medium w-48">From Date</p>:{" "}
                    <span className="ml-2 text-gray-700">
                      {convertDateName(fromDate) || 0}
                    </span>
                  </div>
                  <div className="flex -mt-4">
                    <p className="font-medium w-48">To Date</p>:{" "}
                    <span className="ml-2 text-gray-700">
                      {convertDateName(toDate) || 0}
                    </span>
                  </div>
                  <div className="flex -mt-4">
                    <p className="font-medium w-48">Overall Usable Budget</p>:{" "}
                    <span className="ml-2 text-green-700">
                      {overallBudget === "Loading..." ? (
                        <BiLoaderCircle className="loading-icon mx-auto mt-1" />
                      ) : (
                        formatToINR(overallBudget)
                      )}
                    </span>
                  </div>
                  <div className="flex -mt-4">
                    <p className="font-medium w-48">Posted Amount</p>:{" "}
                    <span className="ml-2 text-green-700">
                      {postedAmount === "Loading..." ? (
                        <BiLoaderCircle className="loading-icon mx-auto mt-1" />
                      ) : (
                        formatToINR(postedAmount)
                      )}
                    </span>
                  </div>
                  <div className="flex -mt-4">
                    <p className="font-medium w-48">Unposted Amount</p>:{" "}
                    <span className="ml-2 text-red-700">
                      {unpostedAmount === "Loading..." ? (
                        <BiLoaderCircle className="loading-icon mx-auto mt-1" />
                      ) : (
                        formatToINR(unpostedAmount)
                      )}
                    </span>
                  </div>
                  <div className="flex -mt-4">
                    <p className="font-medium w-48">Balance Amount</p>:{" "}
                    <span className="ml-2 text-gray-700">
                      {unpostedAmount === "Loading..." ? (
                        <BiLoaderCircle className="loading-icon mx-auto mt-1" />
                      ) : (
                        formatToINR(
                          overallBudget - (postedAmount + unpostedAmount)
                        )
                      )}
                    </span>
                  </div>
                </div>
              ) : null} */}

           {hasSearched && !isClearTable ? (
  <div className="flex flex-wrap lg:flex-nowrap ml-8 mr-8 gap-3 items-stretch">
    {/* Summary Card */}
    <div className="flex flex-col bg-white shadow-lg rounded-md p-3 w-full md:w-full lg:w-[32%] h-[250px] justify-between">
      <div>
        <h3 className="text-base font-bold">
          {projectName === "Loading..." ? (
            <BiLoaderCircle className="loading-icon mx-auto mt-4" />
          ) : (
            projectName
          )}
        </h3>
        <div className="flex justify-between items-center">
          <span className="text-gray-700 text-xs">{projectId}</span>
          <span className="text-gray-700 text-xs">
            <span className="text-gray-900 text-xs">Proj Duration: </span>
            {watch("ProjectId")?.value?.split(":")[0] || "N/A"}
          </span>
        </div>
        <hr className="mt-2 mb-2 border-gray-700" />
        <div className="flex">
          <p className="font-medium w-48">From Date</p>:{" "}
          <span className="ml-2 text-gray-700">
            {convertDateName(fromDate) || 0}
          </span>
        </div>
        <div className="flex -mt-4">
          <p className="font-medium w-48">To Date</p>:{" "}
          <span className="ml-2 text-gray-700">
            {convertDateName(toDate) || 0}
          </span>
        </div>
        <div className="flex -mt-4">
          <p className="font-medium w-48">Overall Usable Budget</p>:{" "}
          <span className="ml-2 text-green-700">
            {overallBudget === "Loading..." ? (
              <BiLoaderCircle className="loading-icon mx-auto mt-1" />
            ) : (
              formatToINR(overallBudget)
            )}
          </span>
        </div>
        <div className="flex -mt-4">
          <p className="font-medium w-48">Posted Amount</p>:{" "}
          <span className="ml-2 text-green-700">
            {postedAmount === "Loading..." ? (
              <BiLoaderCircle className="loading-icon mx-auto mt-1" />
            ) : (
              formatToINR(postedAmount)
            )}
          </span>
        </div>
        <div className="flex -mt-4">
          <p className="font-medium w-48">Unposted Amount</p>:{" "}
          <span className="ml-2 text-red-700">
            {unpostedAmount === "Loading..." ? (
              <BiLoaderCircle className="loading-icon mx-auto mt-1" />
            ) : (
              formatToINR(unpostedAmount)
            )}
          </span>
        </div>
        <div className="flex -mt-4">
          <p className="font-medium w-48">Balance Amount</p>:{" "}
          <span className="ml-2 text-gray-700">
            {unpostedAmount === "Loading..." ? (
              <BiLoaderCircle className="loading-icon mx-auto mt-1" />
            ) : (
              formatToINR(overallBudget - (postedAmount + unpostedAmount))
            )}
          </span>
        </div>
      </div>
    </div>

{/* Donut Chart with Center Text */}
<div className="flex flex-col bg-white shadow-lg rounded-md p-3 w-full md:w-full lg:w-[32%] h-[250px] justify-between">
  {overallBudget === "Loading..." ? (
    <div className="flex items-center justify-center h-full w-full">
      <BiLoaderCircle className="animate-spin text-blue-500" size={50} />
    </div>
  ) : (
    <div className="flex w-full h-full items-center justify-between relative">
      {/* Doughnut Chart */}
      <div className="relative" style={{ width: "200px", height: "200px" }}>
        <Doughnut
          data={{
            labels: ["Posted Amount", "Unposted Amount", "Balance Amount"],
            datasets: [
              {
                data: [
                  postedAmount,
                  unpostedAmount,
                  Math.max(overallBudget - (postedAmount + unpostedAmount), 0),
                ],
                backgroundColor: ["#047857", "#F87171", "#9CA3AF"],
                borderWidth: 2,
                borderColor: "#fff",
                hoverOffset: 10,
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            cutout: "70%",
            animation: { animateRotate: true, animateScale: true },
            plugins: {
              legend: { display: false },
              //tooltip: { enabled: true },
              tooltip: {
      enabled: true,
      callbacks: {
        label: function (context) {
          const label = context.label || "";
          const value = context.parsed || 0;
          return `${label}: ${formatToINR(value)}`;
        },
         },
    },
              datalabels: {
  color: "#ffffff", // white text
  font: { weight: "bold", size: 12 },
  textStrokeColor: "#000000", // black border around text
  textStrokeWidth: 2,         // thickness of the outline
  formatter: (value, ctx) => {
    const sum = ctx.chart.data.datasets[0].data.reduce((a, b) => a + b, 0);
    const percentage = ((value / sum) * 100).toFixed(1) + "%";
    return percentage;
  },
},
            },
          }}
          plugins={[ChartDataLabels]}
        />

        {/* Center Text */}
        {/* <div className="absolute inset-0 flex flex-col items-center justify-center text-center pointer-events-none">
          <p className="text-[11px] text-gray-600 font-medium leading-tight mb-[1px]">
            Overall Usable Budget
          </p>
          <p className="text-[13px] font-bold text-gray-900 mt-0">
            {formatToINR(overallBudget)}
          </p>
        </div> */}
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center pointer-events-none leading-tight z-0">
  <p className="text-xs text-gray-600 font-medium mb-[1px]">
    Overall Usable Budget
  </p>
  <p className="text-sm font-bold text-gray-900 mt-0">
    {formatToINR(overallBudget)}
  </p>
</div>

      </div>

      {/* Label Box beside donut */}
      <div className="ml-3 bg-white border border-gray-300 rounded-md p-2 text-[11px] leading-5 shadow-sm">
        <p className="flex items-center gap-1">
          <span className="w-3 h-3 inline-block bg-[#047857] rounded-sm"></span>
          Posted Amount
        </p>
        <p className="flex items-center gap-1">
          <span className="w-3 h-3 inline-block bg-[#F87171] rounded-sm"></span>
          Unposted Amount
        </p>
        <p className="flex items-center gap-1">
          <span className="w-3 h-3 inline-block bg-[#9CA3AF] rounded-sm"></span>
          Balance Amount
        </p>
      </div>
    </div>
  )}
</div>



      
{/* Project Activity Trend Chart */}
<div className="flex flex-col bg-white shadow-lg rounded-md p-3 w-full md:w-full lg:w-[32%] h-[250px] justify-between">
  
  {overallBudget === "Loading..." ? ( // Re-using overallBudget loading state
    <div className="flex items-center justify-center h-full w-full">
      <BiLoaderCircle className="animate-spin text-blue-500" size={50} />
    </div>
  ) : (
    <>
      {dataLength > 0 ? (
        <>
        <h3 className="text-base font-bold mb-2 text-gray-800 text-center">Budget Trend</h3>
          <div className="w-full h-[160px] flex items-center justify-center">
            <Bar
              data={{
                labels: paginatedData.map(row => row.ProjectCategoryId),
                datasets: [
                  {
                    label: 'Overall Budget',
                    data: paginatedData.map(row => row.OverallBudgetAmount),
                    backgroundColor: '#0EA5E9', // Blue
                  },
                  {
                    label: 'Balance Amount',
                    // Use the pre-calculated balance from useMemo
                    data: paginatedData.map(row => row.BalanceAmountCalculated), 
                    backgroundColor: '#047857', // Green
                  },
                ],
              }}
              options={{
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                  legend: {
                    position: 'top',
                    labels: { boxWidth: 12, font: { size: 10 } }
                  },
                  tooltip: {
                    callbacks: {
                      // Custom tooltip to show INR format
                      label: function(context) {
                        let label = context.dataset.label || '';
                        if (label) { label += ': '; }
                        if (context.parsed.y !== null) { label += formatToINR(context.parsed.y); }
                        return label;
                      }
                    }
                  },
                  datalabels: { display: false } // Hide data labels for cleaner bar chart
                },
                scales: {
                  x: {
                    title: { display: true, text: 'D365 Code', font: { size: 10 } },
                    ticks: { font: { size: 8 } }
                  },
                  y: {
                    beginAtZero: true,
                    title: { display: true, text: 'Amount (INR)', font: { size: 10 } },
                    ticks: {
                      // Format y-axis ticks to show abbreviated INR value
                      callback: function(value) {
                          return formatToINR(value).split(' ')[1]; // e.g., '10,000'
                      },
                      font: { size: 8 }
                    },
                  },
                },
              }}
              height={160}
            />
          </div>
          {dataLength > itemsPerPage && (
            <div className="flex justify-center items-center mt-2 text-sm gap-2">
              <button
                onClick={handlePrevPage}
                disabled={currentPage === 1}
                className={`px-3 py-1 text-xs rounded-md ${currentPage === 1 ? 'bg-gray-200 text-gray-500 cursor-not-allowed' : 'bg-blue-500 text-white hover:bg-blue-600'}`}
              >
                Previous
              </button>
              <span className="text-xs">Page {currentPage} of {totalPages}</span>
              <button
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
                className={`px-3 py-1 text-xs rounded-md ${currentPage === totalPages ? 'bg-gray-200 text-gray-500 cursor-not-allowed' : 'bg-blue-500 text-white hover:bg-blue-600'}`}
              >
                Next
              </button>
            </div>
          )}
        </>
      ) : (
        <div className="flex items-center justify-center h-full text-gray-500">
          No relevant Project Activities to display.
        </div>
      )}
    </>
  )}
</div>




  </div>
) : null}







      {/* View Details button: centered, same blue style as Search, toggles table visibility */}
      {hasSearched && !isClearTable && data.length > 0 && (
        <div className="flex justify-center mt-3 -mb-1">
          <button
            className={`bg-blue-500 text-white font-medium px-4 py-2 rounded ${
              !summaryLoaded ? "opacity-50 cursor-not-allowed" : "hover:bg-blue-600"
            }`}
            //onClick={() => setTableVisible((prev) => !prev)}
            onClick={() => {
    // 1. Get the current visibility state BEFORE the toggle
    const willBeVisible = !tableVisible;
    
    // 2. Toggle the visibility state
    setTableVisible((prev) => !prev);

    // 3. Scroll to the table if it is about to be shown
    if (willBeVisible) {
      // Use a slight delay to ensure the component has rendered and the DOM has updated
      setTimeout(() => {
        tableRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'start', // Scrolls the element to the top of the viewport
        });
      }, 100); // 100ms is usually enough
    }
  }}
            disabled={!summaryLoaded}
            title={!summaryLoaded ? "Loading summary..." : tableVisible ? "Hide details" : "View details"}
          >
            {!summaryLoaded ? (
              <span className="flex items-center">
                <BiLoaderCircle className="animate-spin mr-2" />
                Loading...
              </span>
            ) : tableVisible ? (
              "Hide Details"
            ) : (
              "View Details"
            )}
          </button>
        </div>
      )}

      {/* Table: only render when user toggles it on (tableVisible === true) */}
      {tableVisible && (
      <div className="px-8 pt-4 pb-4" ref={tableRef}>
        <div className="max-h-72 overflow-y-auto border border-gray-400">
          <table className="min-w-full table-auto text-sm border-collapse border-b-8 border-gray-400">
            <thead className="sticky top-0 bg-slate-300 border-b border-gray-400 z-20">
              <tr>
                <th
                  className="px-2 py-2 text-center font-bold border-r border-l border-t border-gray-400 cursor-pointer"
                  onClick={() => handleSort("ProjectCategoryId")}
                >
                  D365 Code {getArrow("ProjectCategoryId")}
                </th>
                <th
                  className="px-2 py-2 text-center font-bold border-r border-t border-gray-400 cursor-pointer"
                  onClick={() => handleSort("ProjectActivityNumber")}
                >
                  Project Activity No. {getArrow("ProjectActivityNumber")}
                </th>
                <th
                  className="px-2 py-2 text-center font-bold border-r border-t border-gray-400 cursor-pointer"
                  onClick={() => handleSort("OverallBudgetAmount")}
                >
                  Overall Budget in INR {getArrow("OverallBudgetAmount")}
                </th>
                <th
                  className="px-2 py-2 text-center font-bold border-r border-t border-gray-400 cursor-pointer"
                  onClick={() => handleSort("PostedAmount")}
                >
                  Posted Amount {getArrow("PostedAmount")}
                </th>
                <th
                  className="px-2 py-2 text-center font-bold border-r border-t border-gray-400 cursor-pointer"
                  onClick={() => handleSort("UnpostedAmount")}
                >
                  Unposted Amount {getArrow("UnpostedAmount")}
                </th>
                <th
                  className="px-2 py-2 text-center font-bold border-r border-t border-gray-400 cursor-pointer"
                  onClick={() => handleSort("BalanceAmount")}
                >
                  Balance Amount {getArrow("BalanceAmount")}
                </th>
                <th className="px-2 py-2 text-center font-bold border-r border-t border-l border-gray-400">
                  View Details
                </th>
              </tr>
            </thead>
            <tbody className="bg-white min-h-screen">
              {isClearTable ? (
                <tr>
                  <td
                    colSpan="7"
                    className="text-center text-gray-500 italic py-2"
                  >
                    You have modified the input. Please hit the search button to
                    see the updated result.
                  </td>
                </tr>
              ) : (
                sortedData.map((row, index) => (
                  <tr
                    key={index}
                    className={`hover:bg-gray-50 ${
                      index % 2 === 0 ? "bg-slate-100" : "bg-white"
                    }`}
                  >
                    <td className="px-2 py-2 border-r border-l border-gray-400 text-center">
                      {row.ProjectCategoryId}
                    </td>
                    <td className="px-2 py-2 border-r border-gray-400 text-center">
                      {row.ProjectActivityNumber}
                    </td>
                    {/* MODIFICATION HERE: Check for "Adv Emp" or "Adv Vendor" */}
                    <td className="px-2 py-2 border-r border-gray-400 text-center">
                      {row.ProjectCategoryId === "Adv Emp" ||
                      row.ProjectCategoryId === "Adv Vendor" ? (
                        "-"
                      ) : row.OverallBudgetAmount === "Loading..." ? (
                        <BiLoaderCircle className="loading-icon mx-auto" />
                      ) : (
                        formatToINR(row.OverallBudgetAmount)
                      )}
                    </td>
                    <td className="px-2 py-2 border-r border-gray-400 text-center">
                      {row.PostedAmount === "Loading..." ? (
                        <BiLoaderCircle className="loading-icon mx-auto" />
                      ) : (
                        formatToINR(row.PostedAmount)
                      )}
                    </td>
                    <td className="px-2 py-2 border-r border-gray-400 text-center">
                      {row.UnpostedAmount === "Loading..." ? (
                        <BiLoaderCircle className="loading-icon mx-auto" />
                      ) : (
                        formatToINR(row.UnpostedAmount)
                      )}
                    </td>
                    {/* Showing "-" for "Adv Vendor" and "Adv Emp" in Balance Amount */}
                    <td className="px-2 py-2 border-r border-gray-400 text-center">
                      {row.ProjectCategoryId === "Adv Vendor" ||
                      row.ProjectCategoryId === "Adv Emp" ? (
                        "-"
                      ) : row.UnpostedAmount === "Loading..." ? (
                        <BiLoaderCircle className="loading-icon mx-auto" />
                      ) : (
                        formatToINR(
                          row.OverallBudgetAmount -
                            (row.PostedAmount + row.UnpostedAmount)
                        )
                      )}
                    </td>
                    <td className="px-2 py-2 border-r border-gray-400 text-center">
                      <button
                        className={`${
                          (row.PostedAmount === 0 &&
                            row.UnpostedAmount === 0) ||
                          row.PostedAmount === "Loading..."
                            ? "text-gray-500"
                            : "text-blue-500"
                        }`}
                        onClick={() => handleShowDetails(row)}
                        disabled={
                          (row.PostedAmount === 0 &&
                            row.UnpostedAmount === 0) ||
                          row.PostedAmount === "Loading..."
                        }
                        title={
                          (row.PostedAmount === 0 &&
                            row.UnpostedAmount === 0) ||
                          row.PostedAmount === "Loading..."
                            ? "No details to show"
                            : "View details"
                        }
                      >
                        {(row.PostedAmount === 0 &&
                          row.UnpostedAmount === 0) ||
                        row.PostedAmount === "Loading..." ? (
                          <HiMiniEyeSlash />
                        ) : (
                          <HiMiniEye />
                        )}
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          {showModal && (
            <NewModalCard
              showModal={showModal}
              setShowModal={setShowModal}
              props={modalData}
            />
          )}
        </div>
      </div>
      )}
    </>
  ) : (
    <>
      {searchLoading && (
        <div>
          <div className="flex items-center justify-center p-4">
            <BiLoaderCircle
              className="animate-spin text-blue-500"
              size={50}
            />
          </div>
        </div>
      )}
              {isError && (
                <div className="flex items-center justify-center p-4 text-red-500">
                  Error fetching data. Please try again later.
                </div>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
}

export default FormPage;
